
const productCardRoutes = [
    {
        path:'list',
        name:'productCard-list',
        component: () => import(/* webpackChunkName: "about" */ '@/views/productCard/list.vue')
    },
    {
        path:'add',
        name:'productCard-add',
        component: () => import(/* webpackChunkName: "about" */ '@/views/productCard/add.vue')
    },
    {
        path:'detail/:card_id',
        name:'productCard-detail',
        component: () => import(/* webpackChunkName: "about" */ '@/views/productCard/detail.vue')
    },
   
]
export default productCardRoutes